import * as React from 'react';
import clsx from 'clsx';

import * as styles from './RecommendationDesktopSkeleton.css';

export const RecommendationDesktopSkeleton: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={clsx(styles['skeleton'], styles['image'])} />
      <div className={styles['info']}>
        <div className={clsx(styles['skeleton'], styles['short'])} />
        <div className={styles['skeleton']} />
        <div className={styles['skeleton']} />
        <div className={styles['skeleton']} />
      </div>
    </div>
  );
};
